<template>
  <div class="imgBox" >
    <div class="imgWrap" v-for='(item,index) in img'>
      <div :style="'background:url(' +item+ ');background-size:100% 100%;'">
        <img style="opacity:0;" :src="item" alt="">
        <img style="position:absolute;z-index:11;top:0;opacity:0;" :src="item" preview='2' preview-text alt="">
      </div>
      <span>
        <!-- <img style="opacity:0;position:absolute;z-index:10;width:100%;height:100%;" :src="item" preview='2' preview-text alt=""> -->
        <img src="../assets/look.png" alt="">
        放大证照
      </span>
    </div>
    <!-- <viewer :images="img">
        <img v-for="src in img" :src="src.url" :key="src.title">
    </viewer> -->
  </div>
</template>

<script>
import store from '../store.js'
import { MessageBox,Toast,Indicator } from 'mint-ui'
import QRCode from 'qrcodejs2';
//import img1 from '../assets/pic_sfz@2x.png';
export default {
  name: 'App',
  data () {
    return {
       img: store.state.imgData,
      // img: [
      //   img1,img1,img1
      // ],
      // com:[]
    }
  },

  mounted() {        //写在mounted或者activated生命周期内即可
    this.$preview.on('imageLoadComplete',(e,item)=>{
						console.log(this.$preview.self)
					})
    },
  created(){
    if(sessionStorage.index==1){
      this.toInfo();
    }
    sessionStorage.index=1;
    // let arr =[];
    //   for(var i=0;i<this.img.length;i++){
    //     console.log(this.compress(this.img[i],1800,0.7));
    //     this.compress(this.img[i],1800, 0.5).then(val => {
		//         arr.push(val)
		//     });
    //     //arr.push(this.compress(this.img[i],1800,0.7));
    //   }
    //   console.log(arr);
    //   this.com = arr;
  },
  methods:{
    toInfo (){
      let that = this;
      this.$axios({
        method: 'get',
        url: '/user/certs/info/getStr?token='+sessionStorage.token+'&code='+sessionStorage.code,

      }).then(function (res) {
        Indicator.close();
        if(res.data.error==0){
          that.img=res.data.data;
        }else {
          Toast({
            message: res.data.message,
            position: 'bottom',
            duration: 1000
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<style lang='scss' scoped="">
  .imgBox {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    overflow: auto;
  }
  img {
    width: 100%;
    background: #ddd;
    display: block;
  }
  .imgWrap {
    position: relative;
    span {
      position: absolute;
      bottom: 20px;
      display: block;
      padding:5px 10px;
      left: 50%;
      margin-left: -45px;
      color: #fff;
      font-size: 14px;
      background: rgba(0,0,0,0.3);
      border-radius: 20px;
      img {

        width: 20px;
        display: block;
        background: none;
        float: left;
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/info.vue